export default function Confidencial() {
  return (
    <div>
      <div className="main_block_login">
        <div className={"ofeta_block"}>
          <div
            style={{
              textAlign: "center",
              color: "white",
              fontWeight: "bolder",
              fontSize: "18px",
            }}
          >
            Политика конфиденциальности
          </div>
          <ul>
            <ol>
              1. Общие положения
              <div>
                1.1. Настоящая Политика конфиденциальности определяет порядок
                обработки и защиты информации о Пользователях, которую
                Самозанятый [Ваше ФИО], ИНН [Ваш ИНН] (далее — «Оператор»),
                может получить при использовании сайта [URL вашего сайта] (далее
                — «Сайт»). 1.2. Использование Сайта означает безоговорочное
                согласие Пользователя с настоящей Политикой конфиденциальности.
              </div>
            </ol>
            <ol>
              2. Состав обрабатываемых данных
              <div>
                2.1. Оператор обрабатывает только минимально необходимые данные
                для функционирования Сайта: Электронная почта (e-mail) IP-адрес
                Данные cookies Информация о браузере и устройстве История
                покупок и активности на Сайте 2.2. Оператор не обрабатывает
                специальные категории персональных данных.
              </div>
            </ol>
            <ol>
              3. Цели обработки данных
              <div>
                3.1. Данные обрабатываются исключительно для: Предоставления
                доступа к функционалу Сайта Обработки платежей и выдачи ключей
                доступа Обеспечения безопасности Сайта Технической поддержки
                Пользователей Выполнения требований законодательства РФ
              </div>
            </ol>
            <ol>
              4. Правовые основания обработки
              <div>
                4.1. Обработка данных осуществляется на основании: Федерального
                закона от 27.07.2006 № 152-ФЗ «О персональных данных» Согласия
                Пользователя на обработку данных Необходимости для исполнения
                договора оферты
              </div>
            </ol>
            <ol>
              5. Сроки хранения данных
              <div>
                5.1. Персональные данные хранятся: До достижения целей обработки
                До истечения сроков, установленных законодательством РФ До
                отзыва согласия Пользователем
              </div>
            </ol>
            <ol>
              6. Передача данных третьим лицам
              <div>
                6.1. Оператор может передавать данные: Платежным системам
                (ЮKassa) - только в объеме, необходимом для обработки платежей
                Хостинг-провайдерам - для технического обеспечения работы Сайта
                Государственным органам - в случаях, предусмотренных
                законодательством РФ 6.2. При передаче данных обеспечивается их
                конфиденциальность и безопасность.
              </div>
            </ol>
            <ol>
              7. Файлы cookies
              <div>
                7.1. Сайт использует cookies для: Аутентификации Пользователей
                Сохранения настроек и предпочтений Сбора статистики посещаемости
                Обеспечения безопасности 7.2. Пользователь может отключить
                cookies в настройках браузера.
              </div>
            </ol>
            <ol>
              8. Защита данных
              <div>
                8.1. Оператор принимает необходимые организационные и
                технические меры для защиты данных от неправомерного доступа.
              </div>
            </ol>
            <ol>
              9. Права Пользователей
              <div>
                9.1. Пользователь имеет право: На доступ к своим персональным
                данным На уточнение, блокирование или уничтожение данных На
                отзыв согласия на обработку данных На обжалование действий
                Оператора
              </div>
            </ol>
            <ol>
              10. Контактная информация
              <div>
                10.1. По вопросам обработки персональных данных обращаться:
                Email: [ваш email] Телефон: [ваш телефон] ИНН самозанятого: [Ваш
                ИНН]
              </div>
            </ol>
            <ol>
              11. Заключительные положения
              <div>
                11.1. Настоящая Политика может изменяться Оператором в
                одностороннем порядке. 11.2. Новая редакция Политики вступает в
                силу с момента ее размещения на Сайте.
              </div>
            </ol>
          </ul>
        </div>
      </div>
      <div className="footer"></div>
    </div>
  );
}
